import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import applySearchParams from "libs/applySearchParams";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "../constants/DemandValidation";
import isResponseValid from "../libs/isResponseValid";
import DemandSectionsService from "./DemandSectionsService";
import Tr from "../translations/Translations";
import {DemandValidationSectionStatus} from "../constants/DemandValidationSectionStatus";

const OFFER_CHOICE_LIST_RESOURCE_ID = 'offerChoiceList';
const OFFER_CHOICE_JUSTIFICATIONS = 'choiceJustificationBasis';

const getChoiceList = async (demandId, pagination, search) => {
    const params = {
        ...pagination
    };
    applySearchParams(search, params);
    try {
        const resp = await RestRequestGET(Endpoints.OFFER_CHOICE(demandId), {params});
        reduxStore.dispatch(setResource(OFFER_CHOICE_LIST_RESOURCE_ID, resp));
    } catch (error) {
    }
};
const getPositionAuctions = async (demandId, positionId) => {
    return await RestRequestGET(Endpoints.OFFER_CHOICE_PREPARE_AUCTION_INFO(demandId, positionId));
};

const updatePosition = async (demandId, positionId, sectionsToRefresh) => {
    try {
        const resp = await RestRequestGET(Endpoints.OFFER_CHOICE_GET_POSITION(demandId, positionId));
        if (isResponseValid(resp)) {
            _doUpdatePosition(resp);
            await callSectionsValidation(demandId, sectionsToRefresh)
        }
    } catch (error) {
    }
};

let updateInProgress = false;
const callSectionsValidation = async (demandId, sectionsToRefresh) => {
    if (!updateInProgress && Array.isArray(sectionsToRefresh)) {
        updateInProgress = true;
        try {
            for (const demandValidation of sectionsToRefresh)
                await validateSection(demandValidation, demandId, false);

        } finally {
            updateInProgress = false;
        }
    }
}

const addAuctionToAdditionalRoundInfo = (positionId, auction) => {
    _doUpdateAuction(positionId, auction, "ADD")
}
const removeAuctionFromAdditionalRoundInfo = (positionId, auction) => {
    _doUpdateAuction(positionId, auction, "DELETE")
}
const updateAuctionInAdditionalRoundInfo = (positionId, auction) => {
    _doUpdateAuction(positionId, auction, "UPDATE")
}


const _doUpdatePosition = (newPos) => {
    const {resources} = reduxStore.getState();

    const curList = resources[OFFER_CHOICE_LIST_RESOURCE_ID];
    if (curList) {
        const newList = {
            ...curList,
            items: curList.items.map(pos => pos.identity !== newPos.identity ? pos : newPos)
        }
        reduxStore.dispatch(setResource(OFFER_CHOICE_LIST_RESOURCE_ID, newList));
    }
}

const _doUpdateAuction = (positionId, auction, mode) => {
    const {resources} = reduxStore.getState();

    const curList = resources[OFFER_CHOICE_LIST_RESOURCE_ID];
    if (curList) {
        const newList = {
            ...curList,
            items: curList.items.map(pos =>
                pos.identity !== positionId ? pos : {
                    ...pos,
                    currentAdditionalRoundInfo: {
                        ...pos.currentAdditionalRoundInfo,
                        auctions: mode === "ADD" ? [...pos.currentAdditionalRoundInfo.auctions, auction] :
                            (mode === "UPDATE" ?
                                    pos.currentAdditionalRoundInfo.auctions.map(auc => auc.auctionId !== auction.auctionId ? auc : auction) :
                                    pos.currentAdditionalRoundInfo.auctions.filter(auc => auc.auctionId !== auction.auctionId)
                            )
                    }
                }
            )
        }
        reduxStore.dispatch(setResource(OFFER_CHOICE_LIST_RESOURCE_ID, newList));
    }
}


const getChoiceJustificationBasis = async (demandId) => {
    try {
        const resp = await RestRequestGET(Endpoints.OFFER_CHOICE_JUSTIFICATIONS(demandId));
        reduxStore.dispatch(setResource(OFFER_CHOICE_JUSTIFICATIONS, resp));
    } catch (error) {
    }
};

const getPositionsWithNoOffer = async (demandId) => {
    try {
        return await RestRequestGET(Endpoints.OFFER_CHOICE_POSITIONS_WITH_NO_OFFER(demandId));
    } catch (error) {
    }
};

const prepareAdditionalRound = async (demandId, roundType) => {
    try {
        return await RestRequestGET(Endpoints.OFFER_CHOICE_PREPARE_ADDITIONAL_ROUND(demandId, roundType));
    } catch (error) {
    }
};

const cancelPositionsWithNoOffer = async (demandId, values) => {

    const data = {
        ...values,
        offerChoiceDate: values.offerChoiceDate.format()
    }

    const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE_CANCEL_WHERE_NO_OFFERS(demandId), data);
    if (resp.success !== true) {
        throw new Error(resp)
    }
    await validateSection(DemandValidation.OFFER_CHOICE, demandId, false);
    await validateSection(DemandValidation.OFFERS_CHOICE_RESULT, demandId, false);
    return resp;
};

const createAdditionalRound = async (demandId, values, roundType) => {
    const data = {
        "endDate": values.endDate ? values.endDate.format() : null,
        "openOfferDate": values.openOfferDate ? values.openOfferDate.format() : null,
        "positions": Object.keys(values.parts).filter(x => values.parts[x].checked === true).map(x => {
            const filteredContractors = Object.keys(values.parts[x].contractors).filter(c => values.parts[x].contractors[c] === true);
            return {
                positionId: x.substring(1),
                departmentIds: !!filteredContractors ? filteredContractors.map(c => c.substring(1)) : []
            }
        }),
        "roundType": roundType
    }
    const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE_CREATE_ADDITIONAL_ROUND(demandId), data);
    await validateSection(DemandValidation.OFFER_CHOICE, demandId, false);
    return resp;
};

const modifyChoice = async (demandId, positionId) => {
    const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE_REVOKE(demandId, positionId));
    if (!(resp.success && resp.result)) {
        throw new Error();
    }
    await validateSection(DemandValidation.OFFER_CHOICE, demandId, false);
    await validateSection(DemandValidation.OFFERS_CHOICE_RESULT, demandId, false);
    const {resources} = reduxStore.getState();
    const approvalSection = resources.demandValidation?.find(x => x.section === DemandValidation.OFFER_CHOICE_APPROVAL);
    if (!!approvalSection && DemandValidationSectionStatus.UNAVAILABLE !== approvalSection.status)
        await validateSection(DemandValidation.OFFER_CHOICE_APPROVAL, demandId, false);
    _doUpdatePosition(resp.result)
}

const saveOfferChoice = async (demandId, positionId, canceled, chosenSupplierIds, offerChoiceDate, offerChoiceJustification) => {
    const data = {
        identity: positionId,
        offerChoiceDate: offerChoiceDate.format(),
        offerChoiceJustification,
        canceled
    };

    if (!canceled) {
        data.chosenSupplierIds = [...chosenSupplierIds]
    }

    const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE(demandId), data);

    if (!(resp.success && resp.result)) {
        throw new Error();
    }
    await validateSection(DemandValidation.OFFER_CHOICE, demandId, false);
    await validateSection(DemandValidation.OFFERS_CHOICE_RESULT, demandId, false);
    const {resources} = reduxStore.getState();
    const approvalSection = resources.demandValidation?.find(x => x.section === DemandValidation.OFFER_CHOICE_APPROVAL);
    if (!!approvalSection && DemandValidationSectionStatus.UNAVAILABLE !== approvalSection.status)
        await validateSection(DemandValidation.OFFER_CHOICE_APPROVAL, demandId, false);
    _doUpdatePosition(resp.result)
}


const checkForPrimaryTenderChoiceOptions = async (demandId) => {
    try {
        const resp = await RestRequestGET(Endpoints.OFFER_CHOICE_PRIMARY_CHECK(demandId));
        return resp;
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}
const postPrimaryTenderDoNegotiations = async (demandId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE_PRIMARY_DO_NEGOTIATIONS(demandId));
        if (isResponseValid(resp, (e) => {throw new Error(e)}))
            await DemandSectionsService.getEvaluationSections(demandId, true)
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
};
const postPrimaryTenderDoOfferChoice = async (demandId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE_PRIMARY_DO_OFFER_CHOICE(demandId));
        if (isResponseValid(resp, (e) => {throw new Error(e)}))
        await DemandSectionsService.getEvaluationSections(demandId, true)
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
};

const validate = async (id) => {
    return RestRequestGET(Endpoints.OFFER_CHOICE_VALIDATE(id));
}

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
};

export default {
    getChoiceList,
    getPositionsWithNoOffer,
    getChoiceJustificationBasis,
    createAdditionalRound,
    prepareAdditionalRound,
    cancelPositionsWithNoOffer,
    saveOfferChoice,
    updateAuctionInAdditionalRoundInfo,
    addAuctionToAdditionalRoundInfo,
    removeAuctionFromAdditionalRoundInfo,
    updatePosition,
    modifyChoice,
    getPositionAuctions,
    checkForPrimaryTenderChoiceOptions,
    postPrimaryTenderDoOfferChoice,
    postPrimaryTenderDoNegotiations,
    validate,
    callSectionsValidation,
    clearResources,
    OFFER_CHOICE_JUSTIFICATIONS,
    OFFER_CHOICE_LIST_RESOURCE_ID
}